export default __webpack_public_path__ + "static/media/radio_button_checked_red_24dp.110d4f2c.svg";